import { render, staticRenderFns } from "./PollSectionHeader.vue?vue&type=template&id=c9dcfd62&scoped=true&"
import script from "./PollSectionHeader.vue?vue&type=script&lang=js&"
export * from "./PollSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./PollSectionHeader.vue?vue&type=style&index=0&id=c9dcfd62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dcfd62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
